import { Form, Formik, FormikValues } from 'formik';
import React, { useEffect, useRef } from 'react';
import * as Yup from 'yup';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';

import FormikButton from '../../../common/formik/FormikButton';
import FormikGrid from '../../../common/formik/FormikGrid';
import FormikTextField from '../../../common/formik/FormikTextField';
import {
  useCreateHazardAction,
  useCreateHazardCause,
  useCreateHazardControl,
  useFindHazard
} from '../Hazard.hooks';
import { HazardAction, HazardCause, HazardControl } from '../Hazard.interface';

export interface HazardCreateEntityDialogProps {
  hazardId: number;
  displayName: string;
  onCancel: () => void;
  onCreated?: (
    hazardEntity: HazardCause | HazardControl | HazardAction
  ) => void;
}

const HazardCreateEntityDialog: React.FC<HazardCreateEntityDialogProps> = ({
  hazardId,
  displayName,
  onCancel,
  onCreated
}) => {
  const formikRef = useRef<FormikValues>();

  const {
    createdHazardCause,
    isCreatingHazardCause,
    createHazardCauseError,
    createHazardCause
  } = useCreateHazardCause(hazardId);

  const {
    createdHazardControl,
    isCreatingHazardControl,
    createHazardControlError,
    createHazardControl
  } = useCreateHazardControl(hazardId);

  const {
    createdHazardAction,
    isCreatingHazardAction,
    createHazardActionError,
    createHazardAction
  } = useCreateHazardAction(hazardId);

  useEffect(() => {
    if (
      !isCreatingHazardCause ||
      !isCreatingHazardControl ||
      !isCreatingHazardAction
    ) {
      if (onCreated && createdHazardCause) {
        onCreated(createdHazardCause);
      }
      if (onCreated && createdHazardControl) {
        onCreated(createdHazardControl);
      }
      if (onCreated && createdHazardAction) {
        onCreated(createdHazardAction);
      }
      if (formikRef && formikRef.current) {
        formikRef.current.setSubmitting(false);
      }
    }
  }, [
    createdHazardCause,
    createdHazardControl,
    createdHazardAction,
    isCreatingHazardCause,
    isCreatingHazardControl,
    isCreatingHazardAction,
    onCreated
  ]);

  return (
    <Dialog maxWidth='xs' open onClose={onCancel}>
      <Formik
        innerRef={(formik: any) => (formikRef.current = formik)}
        initialValues={{
          title: ''
        }}
        validationSchema={Yup.object({
          title: Yup.string().required('Required')
        })}
        onSubmit={(form: any) => {
          displayName === 'causes'
            ? createHazardCause(form)
            : displayName === 'controls'
            ? createHazardControl(form)
            : createHazardAction(form);
        }}
      >
        <Form autoComplete='off'>
          <DialogTitle>Create {displayName}</DialogTitle>
          <DialogContent>
            <FormikGrid>
              <FormikTextField
                autoFocus
                type='text'
                name='title'
                label='Title'
              />
            </FormikGrid>
            {/* {createError && (
              <Alert severity='error'>{`Error occurred. ${createError.message}`}</Alert>
            )} */}
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <FormikButton>Create</FormikButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default HazardCreateEntityDialog;
